
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.585.52l.929.68c.153.112.331.186.518.215l1.138.175a2.678 2.678 0 012.24 2.24l.174 1.139c.029.187.103.365.215.518l.68.928a2.677 2.677 0 010 3.17l-.68.928a1.174 1.174 0 00-.215.518l-.175 1.138a2.678 2.678 0 01-2.241 2.241l-1.138.175a1.17 1.17 0 00-.518.215l-.928.68a2.677 2.677 0 01-3.17 0l-.928-.68a1.174 1.174 0 00-.518-.215L3.83 14.41a2.678 2.678 0 01-2.24-2.24l-.175-1.138a1.17 1.17 0 00-.215-.518l-.68-.928a2.677 2.677 0 010-3.17l.68-.928c.112-.153.186-.331.215-.518l.175-1.14a2.678 2.678 0 012.24-2.24l1.139-.175c.187-.029.365-.103.518-.215l.928-.68a2.677 2.677 0 013.17 0zM7.303 1.728l-.927.68a2.67 2.67 0 01-1.18.489l-1.137.174a1.179 1.179 0 00-.987.987l-.174 1.136a2.677 2.677 0 01-.489 1.18l-.68.928a1.18 1.18 0 000 1.394l.68.927c.256.348.424.753.489 1.18l.174 1.137c.078.509.478.909.987.987l1.136.174a2.67 2.67 0 011.18.489l.928.68c.414.305.979.305 1.394 0l.927-.68a2.67 2.67 0 011.18-.489l1.137-.174a1.18 1.18 0 00.987-.987l.174-1.136a2.67 2.67 0 01.489-1.18l.68-.928a1.176 1.176 0 000-1.394l-.68-.927a2.686 2.686 0 01-.489-1.18l-.174-1.137a1.179 1.179 0 00-.987-.987l-1.136-.174a2.677 2.677 0 01-1.18-.489l-.928-.68a1.176 1.176 0 00-1.394 0zM11.28 6.78l-3.75 3.75a.75.75 0 01-1.06 0L4.72 8.78a.751.751 0 01.018-1.042.751.751 0 011.042-.018L7 8.94l3.22-3.22a.751.751 0 011.042.018.751.751 0 01.018 1.042z"}})])
          )
        }
      }
    